module.exports = __webpack_public_path__ + "static/Unisel3-880d6dadf1f29f41c6e87a21ae48bf9d.jpg";